import styled from 'styled-components'

export default (styled.span || styled.Text)`
  display: block;
  margin: 34px 0 14px 0;
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
`
